import _ from 'lodash'
import { connect } from 'react-redux'

import {
  hideDialog,
  confirmYes,
  confirmNo,
  setFlagCheckStatus,
  setEDACheckStatusError,
  setEDACheckStatusExpired,
  setAppValue,
  unsetEDACheckStatus,
} from 'e-submission/apps/actions'
import { getDialog, isShowDialog } from 'e-submission/apps/selectors'

import Confirmation from './Confirmation'
import ConfirmationAgeChanged from './ConfirmationAgeChanged'
import ConfirmationCheckAcc from './ConfirmationCheckAcc'
import ConfirmationEDA from './ConfirmationEDA'
import ConfirmationOCR from './ConfirmationOCR'
import Error from './Error'
import OTP from './OTP'
import PreviewMultiplePDF from './PreviewMultiplePDF'
import PreviewPDF from './PreviewPDF'
import Signature from './Signature'
import SubmitPayment from './SubmitPayment'
import Syncing from './Syncing'

export const DIALOG = {
  PreviewPDF,
  PreviewMultiplePDF,
  Signature,
  OTP,
  Error,
  Confirmation,
  ConfirmationEDA,
  ConfirmationOCR,
  ConfirmationCheckAcc,
  ConfirmationAgeChanged,
  SubmitPayment,
  Syncing,
}

/* istanbul ignore next */
export default connect(
  (state) => ({
    dialog: getDialog(state),
    isOpen: isShowDialog(state),
  }),
  {
    hideDialog,
    confirmYes,
    confirmNo,
    setFlagCheckStatus,
    setEDACheckStatusError,
    setEDACheckStatusExpired,
    setAppValue,
    unsetEDACheckStatus,
  }
)((props) => {
  const { dialog, isOpen, hideDialog } = props
  if (!isOpen || !_.has(DIALOG, dialog.name)) return null
  const Modal = DIALOG[dialog.name] || (() => null)
  const toggle = (e) => {
    if (e) {
      e.preventDefault()
    }
    hideDialog()
  }
  return <Modal {...props} {...dialog} toggle={toggle} />
})
